import { StationType } from './const';

interface MockMonitorItem {
  id: number;
  circuitId: number;
  circuitName: string;
  loadRate: number;
}

interface MockStationNode {
  id: number;
  type: StationType;
  name: string;
  level: number;
  powerCircuitList: number[];
  monitorCircuitList: number[];
  monitorItemList: MockMonitorItem[];
  children: MockStationNode[];
}

let stationId = 0;
let monitorId = 0;

const station = (
  name: string,
  level: number,
  loadRate?: number | number[],
  children: MockStationNode[] = []
): MockStationNode => {
  stationId += 1;
  const loadRates = loadRate === undefined ? [] : Array.isArray(loadRate) ? loadRate : [loadRate];

  return {
    id: 920000 + stationId,
    type: StationType.DistributionStation,
    name,
    level,
    powerCircuitList: [],
    monitorCircuitList: [],
    monitorItemList: loadRates.map((rate, index) => {
      monitorId += 1;
      return {
        id: 930000 + monitorId,
        circuitId: 900000 + monitorId,
        circuitName: `${name}监测回路${loadRates.length > 1 ? index + 1 : ''}`,
        loadRate: rate / 100,
      };
    }),
    children,
  };
};

// 现场照片中文字受拍摄距离、透视和反光影响，以下数据优先还原可确认的
// 3 个总回路、各层节点数量和父子结构，用于验证同级站房同行展示。
export const customerLayoutMock = {
  powerSystemList: [
    {
      circuitId: 900001,
      circuitName: '35kV降压总站1#主变系统总线',
      circuitSwitchStatus: 1,
      loadRate: 0.3813,
      powerSystemBusPaiList: [
        {
          busPaiId: 910001,
          busPaiName: 'Ⅰ段',
          powerCircuitList: [],
          powerSystemConfigurationTree: [
            station('4#配电站', 2, 28.23, [
              station('4-4/配变电站高压', 3, 46, [
                station('4-9#变电站', 4),
                station('4-10#变电站', 4, 17.53),
                station('4-11#变电站', 4, 13.68),
                station('4-4#配变电站低压', 4, 33.86),
                station('4-13#变电站', 4, 6.63),
                station('海工大楼变电站', 4, 27.84),
                station('4-1#变电站', 4),
                station('4-2#变电站', 4, 6.24),
                station('4-3#变电站', 4, 1.64),
                station('4-5#变电站', 4, 25.95),
                station('4-6#变电站', 4, 15.62),
                station('4-7#变电站', 4),
                station('2-2#变电站', 4, 7),
                station('2-3#变电站', 4, 17.18),
                station('2-4#变电站', 4),
                station('2-5#变电站', 4, 8.77),
                station('2-6#变电站', 4, 14.41),
                station('2-7#变电站', 4, 27.56),
                station('2-8#变电站', 4),
                station('1-2#变电站', 4, 8.43),
                station('4#宿舍', 4, 19.98),
                station('1-1#变电站', 4),
                station('1-6#变电站', 4, 31.33),
                station('1#变电站', 4, 31.17),
              ]),
              station('6#箱变', 3, 21.36),
            ]),
            station('2#配电站', 2, 8.01, [station('2#变电站', 3, 11.8)]),
            station('1#配电站', 2, 13.02, [station('1#箱变', 3, 15.33)]),
            station('0-3#变电站', 2),
            station('0-1#变电站', 2, 8.74),
            station('0-2#变电站', 2, 2.85),
            station('8#箱变', 2, 9.72),
          ],
        },
      ],
    },
    {
      circuitId: 900002,
      circuitName: '35kV降压总站2#主变系统总线',
      circuitSwitchStatus: 1,
      loadRate: 0.4549,
      powerSystemBusPaiList: [
        {
          busPaiId: 910002,
          busPaiName: 'Ⅱ段',
          powerCircuitList: [],
          powerSystemConfigurationTree: [
            station('5#配电站', 2, 44.82, [
              station('5-1#变电站', 3, 56.17),
              station('5-2#变电站', 3, 18.35),
              station('5-3#变电站', 3, 12.06),
              station('5-10#变电站', 3, 42.49),
              station('5-11#变电站', 3, 23.1),
              station('5-12#变电站', 3, 8.17),
              station('5-13#变电站', 3, 17.54),
              station('5-14#变电站', 3, 25.71),
            ]),
            station('0-7#变电站', 2, [6.88, 12.79]),
            station('0-8#变电站', 2, [13.77, 8.73]),
          ],
        },
        {
          busPaiId: 910003,
          busPaiName: 'Ⅲ段',
          powerCircuitList: [],
          powerSystemConfigurationTree: [
            station('0-6#变电站', 2, 11.77),
            station('0-4#变电站', 2, 11.08),
            station('1#配电站', 2, 4.67, [
              station('1-4#变电站', 3, 9.58),
              station('1-1#变电站', 3, 12.44),
              station('1-6#变电站', 3, 8.03),
              station('1-7#变电站', 3, 6.89),
            ]),
            station('2#箱变', 2, 30.15, [station('2-1#变电站', 3, 36.82)]),
          ],
        },
      ],
    },
    {
      circuitId: 900003,
      circuitName: '35kV降压总站3#主变系统总线',
      circuitSwitchStatus: 1,
      loadRate: 0.5283,
      powerSystemBusPaiList: [
        {
          busPaiId: 910004,
          busPaiName: 'Ⅳ段',
          powerCircuitList: [],
          powerSystemConfigurationTree: [
            station('3#配电站', 2, 51.3, [
              station('3-15#变电站', 3, [18.47, 31.7, 26.4], [station('3-15-1#变电站', 4, 4.93)]),
              station('3-2#变电站', 3, 17.86),
              station('3-3#变电站', 3, 44.18),
              station('3-4#变电站', 3, 12.35),
              station('3-5#变电站', 3, 9.47),
              station('3-6#变电站', 3, 22.99),
              station('3-7#变电站', 3, 11.86),
              station('3-8#变电站', 3, 14.56),
              station('3-9#变电站', 3, 9.71),
              station('3-10#变电站', 3, 28.03),
              station('3-11#变电站', 3, 3.84),
            ]),
            station('4#配电站', 2, 34.7, [
              station('4-4/配变电站高压', 3, 2.05, [
                station('4-11#变电站', 4),
                station('4-15#变电站', 4, 16.43),
                station('4-16#变电站', 4, 5.41),
                station('4-17#变电站', 4, 11.97),
                station('综合服务楼变电站', 4, 12.35),
              ]),
              station('4-1#变电站', 3, [2.23, 8.47]),
              station('4#箱变', 3, 14.44),
              station('4-3#变电站', 3),
              station('4-6#变电站', 3, 19.27),
              station('4-8#变电站', 3, 16.43),
            ]),
            station('2#配电站', 2, 14.9, [
              station('2#箱变', 3, 7.94),
              station('2-1#变电站', 3, [12.97, 17.45]),
              station('2-2#变电站', 3),
              station('2-3/4#变电站', 3, 3.67),
              station('2-5#变电站', 3, 22.97),
              station('2-6#变电站', 3),
              station('2-8#变电站', 3, 28.61),
              station('2-7#变电站', 3, 3.84),
            ]),
            station('0-7#变电站', 2),
            station('0-6#变电站', 2, 16.57),
            station('0-5#变电站', 2, 14.69),
          ],
        },
      ],
    },
  ],
  powerRoomOfFreeList: [],
};
